import { useSelector } from "react-redux";
import { ApiErrorCodes } from "@financeable/lenders/models/components";
// @ts-expect-error: ignoring as it is existing js file
import { applicationSelector } from "@/store/slices/applicationFormSlice";
import type { ApplicationFormSlice, ApplicationState } from "@/store/slices/types/applicationFormSlice";
import type { LenderError } from "@/store/slices/types/lenders";

const useLenderError = () => {
  const { submissionModal } = useSelector<ApplicationFormSlice, ApplicationState>(applicationSelector);
  const { error, message } = submissionModal.submission;
  const errorGroupByCode = Object.groupBy((error as LenderError["error"]) ?? [], (product) => {
    return product.code;
  });
  const errorCodes = ((error as LenderError["error"]) ?? []).map((item) => item.code) ?? [];
  const knownCodes = [ApiErrorCodes.ValidationError, ApiErrorCodes.DataMappingError, ApiErrorCodes.ExternalApiError];
  const errorHasKnownCode = errorCodes.some((code) =>
    knownCodes.includes(
      code as
        | typeof ApiErrorCodes.ValidationError
        | typeof ApiErrorCodes.DataMappingError
        | typeof ApiErrorCodes.ExternalApiError,
    ),
  );
  return { errorGroupByCode, errorHasKnownCode, fallbackMessage: message };
};

export { useLenderError };
